import React from 'react';

import styles from './RemainingRMD.module.scss';
import {
  currency,
  lastBusinessDayNumeric,
} from '../../../utils/dashboard-utils';
import MyToolTip from '../../Shared/MyToolTip/MyToolTip';
import { useSelector } from 'react-redux';
import {
  getRMDFactorTableBoth,
  getRMDFactorTableLifeExpectancy,
  getRMDFactorTableUniformDistribution,
} from '../../../redux/modules/RMD/RMDSetting.selectors';

const DEFAULT_TRIGGER = (
  <p className={styles['rmd-calculated']} aria-label="rmd-calculation">
    How is my RMD calculated?
  </p>
);

const RMDCalculator = ({
  rmdSummary = {},
  year,
  totalRMD,
  multipleLE,
  rmdLifeExpectancy,
  disableValues = false,
  trigger,
}) => {
  const currentRmdYear = rmdSummary.rmdYear;
  const uniformDistribution = useSelector(getRMDFactorTableUniformDistribution);
  const lifeExpectency = useSelector(getRMDFactorTableLifeExpectancy);
  const hasBothTables = useSelector(getRMDFactorTableBoth);
  const totalBalance = currency(rmdSummary.totalBalance);
  return (
    <MyToolTip
      id={`rmd-calculation`}
      descriptionTitle={
        <p className={styles['rmd-poppper-title']}>{`How your ${
          disableValues ? '' : year
        } RMD was calculated`}</p>
      }
      descriptionBody={
        <div>
          <div className={styles['rmd-desc-body']}>
            <div className={styles['rmd-desc-left']}>
              <div className={styles['rmd-year-end']}>Year End IRA Balance</div>
              {disableValues ? (
                <br />
              ) : (
                <>
                  <div className={styles['rmd-date']}>
                    as of {lastBusinessDayNumeric(currentRmdYear)}
                  </div>
                  <div className={styles['total-bal']}>{totalBalance}</div>
                </>
              )}
              <hr className={styles['rmd-divider']} />
              <br />
              <div className={styles['irs-lfe']}>
                IRS Life Expectancy Factor
              </div>
              <div className={styles['total-bal']}>
                {multipleLE ? (
                  <p className={styles['irs-table']}></p>
                ) : (
                  <p className={styles['life-expectancy']}>
                    {rmdLifeExpectancy?.[0]}
                  </p>
                )}
              </div>
            </div>
            <div className={styles['rmd-desc-left']}>
              <hr className={styles['rmd-equal']} />
              <hr className={styles['rmd-equal']} />
            </div>
            <div className={styles['rmd-desc-left']}>
              <div className={styles['irs-lfe']}>
                Required Minimum Distribution
              </div>
              <div className={styles['total-bal']}>{totalRMD}</div>
            </div>
          </div>
          {!hasBothTables && (
            <div className={styles['factor-table-text']}>
              {uniformDistribution && (
                <span>
                  Your life expectancy factor is taken from the{' '}
                  <a
                    className={styles['factor-table-hyperlink']}
                    href={`https://www.irs.gov/pub/irs-pdf/p590b.pdf#page=65`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    IRS Uniform Lifetime Table (PDF)
                  </a>
                </span>
              )}
              {lifeExpectency && (
                <span>
                  Your life expectancy factor is taken from the{' '}
                  <a
                    className={styles['factor-table-hyperlink']}
                    href={`https://www.irs.gov/pub/irs-pdf/p590b.pdf#page=50`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    IRS Joint Life Expectancy Table (PDF)
                  </a>
                </span>
              )}
            </div>
          )}
        </div>
      }
      popOutPlacement="top"
      callerNode={trigger || DEFAULT_TRIGGER}
      maxNoteWidth="468px"
    />
  );
};

export default RMDCalculator;
